import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {PromotionMessageWizardModel} from '../../../../../../models/promotion-message.model';
import {PromotionCampaignModel} from '../../../../../../models/promotion-campaign.model';
import {PromotionMessageService} from '../../../../../../services/promotion/promotion-message.service';
import {CalendarTranslateService} from '../../../../../../modules/UIKit/services/calendarTranslate.service';
import {CalendarTranslate} from '../../../../../../models/calendarTranslate.model';

@Component({
  selector: 'kv-promo-tab-head',
  template: `
    <form (ngSubmit)="saveHeadTab()" [formGroup]="form">
      <div class="ui-g form-group master-data">
        <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'promotion.code', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="code"/>
          </div>
          <div [kv-form-element]="{ label: 'promotion.description', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="description"/>
          </div>
          <div [kv-form-element]="{ label: 'customerInfoSheet.startDate', md: '3'}">
            <p-calendar
              class="over"
              [showIcon]="true"
              formControlName="start_date"
              [readonlyInput]="false"
              [dateFormat]="calendarTranslate.dateFormat">
            </p-calendar>
          </div>
          <div [kv-form-element]="{ label: 'customerInfoSheet.endDate', md: '3'}">
            <p-calendar
              class="over"
              [showIcon]="true"
              formControlName="end_date"
              [readonlyInput]="false"
              [dateFormat]="calendarTranslate.dateFormat">
            </p-calendar>
          </div>
          <div [kv-form-element]="{ label: 'promotion.startRedemDate', md: '3'}">
          <p-calendar
            class="over"
            [showIcon]="true"
            formControlName="start_redem_date"
            [readonlyInput]="false"
            [dateFormat]="calendarTranslate.dateFormat">
          </p-calendar>
        </div>
        <div [kv-form-element]="{ label: 'promotion.endRedemDate', md: '3'}">
          <p-calendar
            class="over"
            [showIcon]="true"
            formControlName="end_redem_date"
            [readonlyInput]="false"
            [dateFormat]="calendarTranslate.dateFormat">
          </p-calendar>
        </div>
          <div [kv-form-element]="{ label: 'promotion.smallDescription', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="small_description"/>
          </div>
          <div [kv-form-element]="{ label: 'promotion.campaignType', md: '6' }">
            <p-dropdown
              [options]="campaignTypes"
              formControlName="campaign_type_id">
            </p-dropdown>
          </div>
          <div [kv-form-element]="{ label: '', md: '2' }"></div>
          <div [kv-form-element]="{ label: 'promotion.priority', md: '2' }">
            <input type="number" min="0" pInputText formControlName="priority" />
          </div>
          <div [kv-form-element]="{ label: '', md: '2' }"></div>
          <div [kv-form-element]="{ label: '', md: '2' }"></div>
          <div style="text-align: center" [kv-form-element]="{ label: 'promotion.pressureRules', md: '2' }">
            <p-inputSwitch formControlName="flag_pressure_rules"></p-inputSwitch>
          </div>
          <div [kv-form-element]="{ label: '', md: '2' }"></div>
        </div>
        <div class="ui-g-12 text-right">
          <button
            pButton
            type="submit"
            class="k-generic-btn"
            icon="fa fa-floppy-o"
            iconPos="left"
            label="{{ 'common.save' | translate }}"
            [disabled]="form.controls['start_date'].value > form.controls['end_date'].value ||
            form.controls['start_redem_date'].value > form.controls['end_redem_date'].value ||
            form.controls['start_date'].value === null ||
            form.controls['end_date'].value === null ||
            form.controls['start_redem_date'].value === null ||
            form.controls['end_redem_date'].value === null ||
            form.controls['code'].value === null ||
            form.controls['campaign_type_id'].value === null">
          </button>
        </div>
      </div>
    </form>
  `,
  providers: [
    CalendarTranslateService
  ],
  styleUrls: ['./tab-head.component.css']
})
export class TabHeadComponent implements OnInit, OnChanges {
  
  @Input() configs: PromotionMessageWizardModel[];
  @Input() addEditCampaign: PromotionCampaignModel;
  @Input() selectedWizard: PromotionCampaignModel;
  @Input() campaignTypes;

  @Output() saveHead = new EventEmitter();

  form: FormGroup;
  calendarTranslate: CalendarTranslate;

  constructor(private fb: FormBuilder,
              private svcMessage: PromotionMessageService,
              private srvCalendarTranslate: CalendarTranslateService) {
    this.srvCalendarTranslate.pCalendar.subscribe(c => {
      this.calendarTranslate = c
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['addEditCampaign'] && changes['addEditCampaign'].currentValue === null) {
      this.createForm()
    } else if (changes['addEditCampaign'] && changes['addEditCampaign'].currentValue !== null) {
      this.createForm(true, changes['addEditCampaign'].currentValue)
    }
  }

  createForm(exist = false, editCampaign: PromotionCampaignModel = null) {
    if (!exist) {
      this.form = this.fb.group({
        'code': this.svcMessage.createField('code', this.configs),
        'start_date': this.svcMessage.createField('start_date', this.configs, null, false, true),
        'end_date': this.svcMessage.createField('end_date', this.configs, null, false, true),
        'start_redem_date': this.svcMessage.createField('start_redem_date', this.configs, null, false, true),
        'end_redem_date': this.svcMessage.createField('end_redem_date', this.configs, null, false, true),
        'description': this.svcMessage.createField('description', this.configs),
        'small_description': this.svcMessage.createField('small_description', this.configs),
        'campaign_type_id': this.svcMessage.createField('campaign_type_id', this.configs),
        'priority': this.svcMessage.createField('priority', this.configs),
        'flag_pressure_rules': this.svcMessage.createField('flag_pressure_rules', this.configs, null, true),
        'wizard_id': this.selectedWizard,
      })
    } else {
      this.form = this.fb.group({
        'code': this.svcMessage.createField('code', this.configs, editCampaign.code),
        'start_date': this.svcMessage.createField('start_date', this.configs, new Date(editCampaign.start_date), false, true),
        'end_date': this.svcMessage.createField('end_date', this.configs, new Date(editCampaign.end_date), false, true),
        'start_redem_date': this.svcMessage.createField('start_redem_date', this.configs, new Date(editCampaign.start_redem_date), false, true),
        'end_redem_date': this.svcMessage.createField('end_redem_date', this.configs, new Date(editCampaign.end_redem_date), false, true),
        'description': this.svcMessage.createField('description', this.configs, editCampaign.description),
        'small_description': this.svcMessage.createField('small_description', this.configs, editCampaign.small_description),
        'campaign_type_id': this.svcMessage.createField('campaign_type_id', this.configs, editCampaign.campaign_type_id),
        'priority': this.svcMessage.createField('priority', this.configs, editCampaign.priority),
        'flag_pressure_rules': this.svcMessage.createField('flag_pressure_rules', this.configs, editCampaign.flag_pressure_rules),
        'wizard_id': this.selectedWizard,
      })
    }
  }

  saveHeadTab() {
    let saveThisHead: PromotionCampaignModel = {
      id: this.addEditCampaign !== null ? this.addEditCampaign.id : null,
      code: this.form.controls['code'].value,
      start_date: this.form.controls['start_date'].value,
      end_date: this.form.controls['end_date'].value,
      start_redem_date: this.form.controls['start_redem_date'].value,
      end_redem_date: this.form.controls['end_redem_date'].value,
      description: this.form.controls['description'].value,
      small_description: this.form.controls['small_description'].value,
      campaign_type_id: this.form.controls['campaign_type_id'].value,
      priority: this.form.controls['priority'].value === null ? 0 : this.form.controls['priority'].value,
      flag_pressure_rules: this.form.controls['flag_pressure_rules'].value,
      wizard_id: this.form.controls['wizard_id'].value
    };
    this.saveHead.emit(saveThisHead);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/tabs/head/tab-head.component.ts